import { Component, OnInit, ElementRef, EventEmitter, Output, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { AttractorLoopService } from '../../../core/routing/services/asset-library/attractor-loop.service';
import * as formFactorsData from './../../../../assets/config/form-factors.json';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { CreateAttractorLoopResponse, AttractorLoop, AttractorLoopConfiguration, AttractorLoopViewModel, AttractLoopVideoViewModel } from '../attractor-loop/interfaces/attractor-loop.i';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { FormFactor, FormFactorsConfig } from '../form-factors/interfaces/form-factors.i'
import { User } from '../../account/login/_models/user.model';
import { AppGlobal } from '../../../core/state/app-global';
import { CommonService } from '../../../common/services/common.service';
import { Utils } from 'src/app/common/utils/utils';
import moment from 'moment';

@Component({
  selector: 'iposcen-create-attractor-loop',
  templateUrl: './create-attractor-loop.component.html',
  styleUrls: ['./create-attractor-loop.component.scss']
})
export class CreateAttractorLoopComponent implements OnInit {
  @Output() readonly goBacktoAttractorLoop = new EventEmitter<object>();
  @Output("refreshAttractorLoopdata") refreshAttractorLoopdata = new EventEmitter<any>();
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('videoInput', { static: false }) videoInput: ElementRef;
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  userId = sessionStorage.getItem('userId');
  publishedNameplaceholder = GlobalConstants.PUBLISHED_NAME;
  internalNamePlaceholder = GlobalConstants.INTERNAL_NAME;
  attractorLoopgrpForm: FormGroup;
  isSubmitted: boolean;
  isFormValid: boolean;
  selectedAttractorLoopId: string;
  isPublishDateCustomDatepicker:boolean;
  isExpiryDatePicker: boolean;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isPublishedDateInCorrect: boolean;
  segmentsForm: FormGroup;
  editexpiryDateInfo: string;
  editPublishDateInfo: string;
  divideDateFormat: boolean = true;
  selectedSegmentId: string;
  selectedFormFactors: FormFactor;
  iposBackgroundType: string;
  isEdit: boolean;
  file: any;
  videoFile: any;
  videoUrl: any;
  videoSizeError: any;
  videoLengthError: any;
  videoTypeError: any;
  videoFileType: string;
  videoFileName: string;
  videoFileSize: number;
  isVideoAvailable = false;
  isVideoFormat: boolean;
  formFactorSelectedAttract: FormFactor
  deviceTypeAttract = GlobalConstants.DEVICE_TYPES;
  manufacturerAttract = GlobalConstants.MANUFACTURERS;
  processorAttract = GlobalConstants.PROCESSORS;
  generationAttract = GlobalConstants.GENERATIONS;
  mediaObjects: any;
  showDevice = false;
  tabIndex = 1;
  editCheck: boolean = false;
  newAttractVideoContentTitle: string = $localize`:@@create-attractor-loop.tab-pane.new-attract-loop-video:NEW ATTRACT LOOP VIDEO`;
  isRemoveEnabled: boolean;
  selectedAttractorLoop: AttractorLoopViewModel;
  attractorLoopVideos: AttractLoopVideoViewModel[];
  buttonLabel: string;
  isImgVideoSizeInfoEnabled: boolean;
  formFactorsData: FormFactorsConfig= (formFactorsData as any)
    .default;
  formFactorProcessorArray = [];
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
    defaultLogoFormFactorsAttractor: FormFactor = {
      allDevices: true,
      devices: GlobalConstants.ALL,
      manufacturer: GlobalConstants.ALL,
      processors: GlobalConstants.ALL,
      generations: GlobalConstants.ALL
      };
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;    
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private attractorLoopService: AttractorLoopService,
    private dataService: DataService,
    private appGlobal: AppGlobal,
    private sanitizer: DomSanitizer,
    private cmnSer: CommonService
  ) { }

  ngOnInit(): void {
    this.isExpiryDatePicker = false;
    this.isPublishDateCustomDatepicker = false;
    this.isExpiredDateIncorrect = false;
    this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
      });
      this.dataService.getAttractorLoop()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((attractorLoopToEdit: any) => {
        this.isImgVideoSizeInfoEnabled = this.cmnSer.isSizeContraintsEnabled;
        if (attractorLoopToEdit) {
          if (attractorLoopToEdit.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            if(attractorLoopToEdit?.configurations?.publishTime) {
            this.isPublishDateCustomDatepicker = true;
            this.customPublishDateResult = attractorLoopToEdit?.configurations?.publishTime;  
            this.editPublishDateInfo = attractorLoopToEdit?.configurations?.publishTime;
            }
          }
          if (attractorLoopToEdit.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editexpiryDateInfo = GlobalConstants.NEVER;
          } else {
            if(attractorLoopToEdit?.configurations?.expireTime) {
              this.isExpiryDatePicker = true;
              this.customExpiryDateResult = attractorLoopToEdit?.configurations?.expireTime;
              this.editexpiryDateInfo = attractorLoopToEdit?.configurations?.expireTime;
            }
          }
          this.buttonLabel = GlobalConstants.SAVE_CHANGES;
          this.editCheck = true;
          this.isVideoFormat = true;
          this.isVideoAvailable = true;
          this.videoUrl = '';
          this.videoUrl = this.isVideoAvailable ? environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.ATTRACTOR_LOOP + AssetLibraryConstants.SLASH +
            attractorLoopToEdit.id : '';
          this.selectedAttractorLoop = attractorLoopToEdit;
          this.selectedAttractorLoopId = attractorLoopToEdit.id;
          this.isVideoAvailable = (this.selectedAttractorLoop.configurations.uploadedVideoName !== '');
          this.videoFileName = this.isVideoAvailable ? this.selectedAttractorLoop.configurations.uploadedVideoName : '';
          this.formFactorSelectedAttract = this.selectedAttractorLoop?.configurations?.formFactor ?  this.selectedAttractorLoop?.configurations?.formFactor : this.defaultLogoFormFactorsAttractor;
        } else {
          this.buttonLabel = GlobalConstants.SAVE_AND_PROCEED;
          this.formFactorSelectedAttract = {
            allDevices: false,
            devices: GlobalConstants.ALL,
            manufacturer: GlobalConstants.ALL,
            processors: this.getNonLegacyProcessorNames(),
            generations: GlobalConstants.ALL
          };
        }
      });
    this.mediaObjects = {
      media: {
        videoFile: '',
        url: '',
        format: '',
        fileObj: ''
      }
    };
    this.isSubmitted = false;
    this.createAttractorLoopGroupForm();
    this.cmnSer.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if (data === true) {
        this.cmnSer.setSwitchstatus(true);
      }
    });
  }
  getNonLegacyProcessorNames() {
    this.formFactorsData.processors.forEach(processor => {
      if (!(processor.name === GlobalConstants.CELERON || processor.name === GlobalConstants.PENTIUM || processor.name === GlobalConstants.NON_INTEL || processor.name === GlobalConstants.INTEL_PROCESSOR)) {
        this.formFactorProcessorArray.push(processor.name);
      }
    });
    const result = this.formFactorProcessorArray.join(', ');
    return result;
  }

  cancel() {
    this.editCheck = false;
    this.isSubmitted = false;
    this.goBacktoAttractorLoop.emit({ cancel: true });
    this.dataService.setAttractorLoop(undefined);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openFormFactorModal() {
    this.openModal(this.formFactorsModal);
  }

  applyFormFactors(updatedFormFactors) {
    this.formFactorSelectedAttract = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }

  createAttractorLoopGroupForm() {
    // TODO -- need to add validations for form fields
    this.attractorLoopgrpForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedAttractorLoop) ?
        this.selectedAttractorLoop.configurations.publishedName : '', [Validators.required, Validators.maxLength(50)]),
      // publishedTimeStamp: new FormControl(''),
      internalName: new FormControl((this.selectedAttractorLoop) ? this.selectedAttractorLoop.configurations.internalName : ''),
      uploadedVideoName: new FormControl('')
      // expiryTimeStamp: new FormControl('', [Validators.minLength(5)])
    });
  }

  createNewAttractorLoop() {
    const promoFactorsAttract: FormFactor = Utils.getFormFactorValues(this.formFactorSelectedAttract);
    const attractorLoop: AttractorLoopConfiguration = {
      publishedName: this.attractorLoopgrpForm.controls.publishedName.value.trim(),
      internalName: this.attractorLoopgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      uploadedVideoName: (!this.videoFile) ? '' : this.videoFile[0]?.name,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker,
      formFactor: promoFactorsAttract
    };
    if(attractorLoop.expireTime !== GlobalConstants.NEVER ){
      attractorLoop.expireTime = Utils.changeSaveDateFormat(attractorLoop.expireTime);
    }
    if(!attractorLoop.isPublishDateNow){
      attractorLoop.publishTime = Utils.changeSaveDateFormat(attractorLoop.publishTime);
    }
    this.attractorLoopService.createAttractorLoop(JSON.stringify(attractorLoop))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createAttractorLoopResponse => {
        const putAttractLoopContentResponseObj: CreateAttractorLoopResponse = createAttractorLoopResponse as CreateAttractorLoopResponse;
        const attractorLoopVideoViewModel: AttractLoopVideoViewModel = createAttractorLoopResponse.attractLoop as AttractLoopVideoViewModel;
        this.mediaObjects = [];
        const dataObj = {
          id: createAttractorLoopResponse.attractLoop.id,
          media: {
            videoFile: this.videoFile[0],
            url: this.videoUrl,
            format: this.videoFile[0].type,
            fileObj: this.videoFile[0].name
          }
        }
        this.mediaObjects.push(dataObj);

        this.attractorLoopService.uploadVideo(this.mediaObjects[0].media.videoFile,
          this.mediaObjects[0].media.format, this.mediaObjects[0].id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(() => {
            this.refreshAttractorLoopdata.emit();
          },
            error => { // do something
            }
          );
      },
        error => {

        });
  }

  updateAttractorLoop() {
    const attractorLoop = this.selectedAttractorLoop as unknown as AttractorLoop;
    const promoFactorsAttract: FormFactor = Utils.getFormFactorValues(this.formFactorSelectedAttract);
    const attractorLoopConfig: AttractorLoopConfiguration = {
      publishedName: this.attractorLoopgrpForm.controls.publishedName.value.trim(),
      internalName: this.attractorLoopgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      uploadedVideoName: (this.videoFile) ? this.videoFile[0].name : this.videoFileName,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker,
      formFactor: promoFactorsAttract,
    };
    if(attractorLoopConfig.expireTime !== GlobalConstants.NEVER ){
      attractorLoopConfig.expireTime = Utils.changeSaveDateFormat(attractorLoopConfig.expireTime);
    }
    if(!attractorLoopConfig.isPublishDateNow){
      attractorLoopConfig.publishTime = Utils.changeSaveDateFormat(attractorLoopConfig.publishTime);
    }
    attractorLoop.configurations = JSON.stringify(attractorLoopConfig);
    this.attractorLoopService.putAttractorLoopById(JSON.stringify(attractorLoop), this.selectedAttractorLoopId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(updateAttractorLoopResponse => {
        const putAttractLoopContentResponseObj: CreateAttractorLoopResponse = updateAttractorLoopResponse as CreateAttractorLoopResponse;
        const attarctorLoopVideoViewModel: AttractLoopVideoViewModel = updateAttractorLoopResponse.attractLoop as AttractLoopVideoViewModel;
        this.mediaObjects = [];
        if (this.videoFile) {
          const dataObj = {
            id: this.selectedAttractorLoopId,
            media: {
              videoFile: this.videoFile[0],
              url: this.videoUrl,
              format: this.videoFile[0].type,
              fileObj: this.videoFile[0].name
            }
          }
          this.mediaObjects.push(dataObj);
          this.attractorLoopService.uploadVideo(this.mediaObjects[0].media.videoFile,
            this.mediaObjects[0].media.format, this.mediaObjects[0].id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(() => {
              // this.refreshAttractorLoopdata.emit();
              if (this.editCheck && updateAttractorLoopResponse.attractLoop.deviceExists) {
                this.openModal(this.applyModal);
              } else {
                this.refreshAttractorLoopdata.emit();
              }
            },
              error => {
                // do something
              });
        } else {
          if (this.editCheck && updateAttractorLoopResponse.attractLoop.deviceExists) {
            this.openModal(this.applyModal);
          } else {
            this.refreshAttractorLoopdata.emit();
          }
        }
      },
        error => {

        });
  }
  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }
  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }
  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  redirectToList() {
    this.closeModal(this.applyModal);
    this.tabIndex = 0;
    this.updateAttractorLoop();
  }

  applyToDevice(applyDevice: boolean) {
    if (!applyDevice) {
      this.refreshAttractorLoopdata.emit();
    } else {
      const attractorLoop: AttractorLoop = this.selectedAttractorLoop as unknown as AttractorLoop;
      const promoFactorsAttract: FormFactor = Utils.getFormFactorValues(this.formFactorSelectedAttract);
      const attractorLoopConfig: AttractorLoopConfiguration = {
        publishedName: this.attractorLoopgrpForm.controls.publishedName.value,
        internalName: this.attractorLoopgrpForm.controls.internalName.value,
        publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
        expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
        uploadedVideoName: (this.videoFile) ? this.videoFile[0].name : this.videoFileName,
        isPublishDateNow: !this.isPublishDateCustomDatepicker,
        isPublishExpiryNever: !this.isExpiryDatePicker,
        formFactor: promoFactorsAttract
      };
      if (typeof attractorLoop.configurations !== 'string') {
        attractorLoop.configurations = JSON.stringify(attractorLoopConfig);
      }
      attractorLoop.ispushedToDevice = applyDevice;
      attractorLoop.showOnDevice = applyDevice;
      this.attractorLoopService.putAttractorLoopById(JSON.stringify(attractorLoop), this.selectedAttractorLoopId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(_ => {
          this.refreshAttractorLoopdata.emit();
          this.closeModal(this.applyModal)
        });
    }
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.redirectToList();
  }

  readVideoUrl(event: any) {
    this.videoFile = event.target.files;
    const reader = new FileReader();
    reader.readAsDataURL(this.videoFile[0]);
    if (this.videoFile[0].type !== GlobalConstants.FILE_TYPE_VIDEO_MP4) {
      this.videoTypeError = true;
      this.isVideoFormat = false;
    } else {
      if (this.videoFile && this.videoFile[0]) {
        this.isVideoFormat = true;
        this.videoUrl = '';
        this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile[0]));
        this.mediaObjects.media.url = this.videoUrl;
      }
    }
    reader.onload = _event => {
      if (this.isVideoAvailable) {
        this.mediaObjects.media.url = '';
      } else {
        this.mediaObjects.media.url = reader.result;
      }
    };
  }

  getDuration(e) {
    const duration = e.target.duration;
    if (this.videoFile?.length) {
      this.videoFileType = this.videoFile[0].type.split('/')[1];
      this.videoFileName = this.videoFile[0].name;
      this.videoFileSize = this.videoFile[0].size;
      this.videoSizeError = this.videoFileSize > GlobalConstants.UPLOAD_VIDEO_MAX_SIZE;
      this.videoTypeError = (this.videoFileType !== GlobalConstants.CONTENT_TYPE_MP4);
    }
    this.videoLengthError = duration > GlobalConstants.UPLOAD_VIDEO_MAX_TIME;
    if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
      this.videoLengthError = false;
      this.videoSizeError = false;
    }
    this.isVideoAvailable = !(this.videoSizeError || this.videoLengthError || this.videoTypeError || (this.videoSizeError && this.videoLengthError && this.videoTypeError));
  }
  checkPublishedDateTime() {
    this.isSubmitted = false;
    const today = new Date();
    let isPublishedDateSmaller;
    if (this.segmentsForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.segmentsForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }
    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }
  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }

  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }
  onAdd() {
    this.isSubmitted = true;
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = this.attractorLoopgrpForm?.controls?.publishedName?.value.trim() !== ''
      && !this.attractorLoopgrpForm?.controls?.publishedName?.errors?.maxlength &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid && !this.isExpiredDateIncorrect && !this.isCustomExpiryDateCorrect && !this.isCustomPublishDateCorrect) {
      if (this.selectedAttractorLoopId) { // Since attractor loop id exists, it is an update process
        this.updateAttractorLoop();
      } else {                            // else new  Attractor loop will created
        this.createNewAttractorLoop();
      }
    }

  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }
  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }
  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }
  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
  
ngOnDestroy() {
  this.ngUnsubscribe.next();
  this.ngUnsubscribe.complete();
}
}

